import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/MP-logo-ICON-01.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  alt: "MP-logo",
  src: _imports_0,
  style: {"width":"200px","height":"160px"}
}, null, -1)

import NewbieApplication from "@/components/NewbieApplication.vue"; // @ is an alias to /src


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

document.title = 'Home'

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(NewbieApplication)
  ]))
}
}

})